<template>
  <b-link @click="action" :class="{ onlyIcon: onlyIcon }" class="btn-social">
    <b-img
      class="w-24"
      :class="{ onlyIcon: onlyIcon, 'btn-social-margin': !onlyIcon }"
      :src="getImage"
      :alt="$t('continueWithDiscord')"
    ></b-img>
    <template v-if="!onlyIcon">
      {{ $t("continueWithDiscord") }}
    </template>
  </b-link>
</template>

<script>
export default {
  name: "UiDiscord",
  props: {
    action: {
      type: Function,
      default: null
    },
    onlyIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getImage() {
      return !this.onlyIcon
        ? `${this.publicPath}assets/images/discord-plain.png`
        : `${this.publicPath}assets/images/discord.png`;
    }
  }
};
</script>
